import React, { useEffect, useState, useCallback } from 'react'
import { chartMock } from '../../mock'
import { getChart } from '../../api'
import './styles.scss'

export const ChartView = ({
  chartsData,
  generateCharts,
  updateSelectedFilters,
  colors,
  type,
}) => {
  const [charts, setCharts] = useState([])

  const getChartData = useCallback(async (config) => {
    const data = await getChart(config)
    return data
  }, [])

  useEffect(() => {
    if (!colors) return
    Object.entries(colors).forEach(([theme, value]) => {
      Object.entries(value).forEach(([colorName, hexValue]) => {
        document.documentElement.style.setProperty(
          `--${colorName}-${theme}`,
          `${hexValue}`,
        )
      })
    })
  }, [colors])

  const getChartsInQueue = useCallback(async () => {
    const data = await Promise.all(
      chartsData.map((query) => getChartData(query)),
    )
    const charts = data.map((item, idx) => {
      let actions = []
      if (item.charts?.slot1_actions?.length) {
        actions = item.charts.slot1_actions.reduce((acc, curr) => {
          const { action, value } = curr
          return { ...acc, [action]: value }
        }, {})
      }

      const { children, position } = chartsData[idx]
      return {
        chartHtml: item.charts.slot1,
        children,
        actions,
        position,
      }
    })
    const POSITIONS_ORDER = ['BTN', 'SB', 'BB']
    const chartsSorted = charts.sort(
      (a, b) =>
        POSITIONS_ORDER.indexOf(a.position) -
        POSITIONS_ORDER.indexOf(b.position),
    )
    setCharts(chartsSorted)
  }, [chartsData, setCharts, getChartData])

  useEffect(() => {
    if (!chartsData) return
    getChartsInQueue()
  }, [chartsData, getChartsInQueue])

  if (!chartsData || !charts.length) {
    const isFiveWay = type === '5way'
    const mockSize = isFiveWay ? 4 : 2
    return (
      <div
        className={`IcmChartView five-way`}
        style={{ position: 'relative' }}
      >
        {Array(mockSize)
          .fill('')
          .map(() => {
            return <div dangerouslySetInnerHTML={{ __html: chartMock }} />
          })}
      </div>
    )
  }

  const getActionColor = (action) => {
    const actionLabel = action.toLowerCase()
    if (
      actionLabel.includes('%') ||
      actionLabel.includes('min') ||
      actionLabel.includes('sb')
    )
      return 'bg-color-raise'
    switch (actionLabel) {
      case 'fold':
        return 'bg-color-fold'
      case 'all in':
        return 'bg-color-allin'
      case 'call':
        return 'bg-color-call'
      default:
        return 'bg-color-oor'
    }
  }

  const getSortedActions = (actions) => {
    return Object.entries(actions)
  }

  return (
    <div className={`IcmChartView five-way`}>
      {charts.map((chart, slot) => {
        const { chartHtml, children, actions, position } = chart
        return (
          <div className="IcmChartView__chart-container" key={position}>
            <div className="IcmChartView__chartView" style={{ fontSize: 24 }}>
              {position}
            </div>
            <div
              className={`IcmChartView__chart-actions five-way`}
            >
              {getSortedActions(actions).map(
                ([actionName, actionPercentage]) => {
                  const option = children.find(
                    (item) => item.name === actionName,
                  )

                  let onClick = () => null
                  if (option) {
                    const { path, root_folder: rootFolder } = option
                    onClick = () => {
                      generateCharts(option, rootFolder, path)
                      updateSelectedFilters({
                        key: `${position} ${option.name}`,
                        value: {
                          ...option,
                          onClick: () =>
                            generateCharts(option, rootFolder, path),
                        },
                      })
                    }
                  }
                  const className = getActionColor(actionName)
                  let actionLabel = actionName.toLowerCase();
                  if (actionLabel.includes("sb") && parseInt(actionLabel) > 0) {
                    actionLabel = `${parseInt(actionName)/10} BB`
                  }

                  return (
                    <div
                      key={actionName}
                      onClick={onClick}
                      className={className}
                      style={{
                        borderRadius: 6,
                        padding: '3px 10px',
                        minWidth: '75px',
                        cursor: option ? 'pointer' : 'default',
                        opacity: option ? 1 : 0.5,
                      }}
                    >
                      <div
                        style={{
                          color: 'white',
                          textTransform: 'uppercase',
                          textAlign: 'center',
                        }}
                      >
                        {actionLabel} ({actionPercentage})
                      </div>
                    </div>
                  )
                },
              )}
            </div>
            <div
              style={{ display: 'flex' }}
              key={slot}
              dangerouslySetInnerHTML={{ __html: chartHtml }}
            ></div>
          </div>
        )
      })}
    </div>
  )
}
